import { render, staticRenderFns } from "./mainFrom.vue?vue&type=template&id=2d56ca4a"
import script from "./mainFrom.vue?vue&type=script&lang=js"
export * from "./mainFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports